
export default {
    path: 'item',
    name: 'company-item',
    meta: {
        title: '项目进度管理'
    },
    component: () => import('@/pages/company/itemManage/Index'),
    redirect: {
        name : 'company-item-land',
    },
    children: [
        {
            path: 'land',
            name: 'company-item-land',
            meta: {
                title: '项目进度管理-单位管理'
            },
            component: () => import('@/pages/company/itemManage/Land'),
        },
        {
            path: 'factory',
            name: 'company-item-factory',
            meta: {
                title: '项目进度管理-单位管理'
            },
            component: () => import('@/pages/company/itemManage/Land'),
        },
        {
            path: 'officebuilding',
            name: 'company-item-officebuilding',
            meta: {
                title: '项目进度管理-单位管理'
            },
            component: () => import('@/pages/company/itemManage/Land'),
        },
        {
            path: 'warehouse',
            name: 'company-item-warehouse',
            meta: {
                title: '项目进度管理-单位管理'
            },
            component: () => import('@/pages/company/itemManage/Land'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/company/itemManage/index.js